import ReactECharts from "echarts-for-react";

interface DonutItem {
  name: string;
  value: number;
}

interface DonutChartProps {
  data: DonutItem[];
  colors?: string[];
  height?: number;
}

const DEFAULT_COLORS = [
  "#00553E",
  "#22c55e",
  "#f97316",
  "#ef4444",
  "#94a3b8",
  "#3b82f6",
  "#a855f7",
];

export function DonutChart({
  data,
  colors = DEFAULT_COLORS,
  height = 280,
}: DonutChartProps) {
  const option = {
    tooltip: { trigger: "item", formatter: "{b}: {c} ({d}%)" },
    legend: { bottom: 0, left: "center", textStyle: { fontSize: 11 } },
    color: colors,
    series: [
      {
        type: "pie",
        radius: ["45%", "70%"],
        center: ["50%", "45%"],
        avoidLabelOverlap: false,
        label: { show: false },
        emphasis: {
          label: { show: true, fontSize: 13, fontWeight: "bold" },
        },
        labelLine: { show: false },
        data,
      },
    ],
  };

  return (
    <ReactECharts
      option={option}
      style={{ width: "100%", height }}
      notMerge
    />
  );
}
